
import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get, pad } from "lodash";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import "./BlockManagement.css";
import Overlay from "../../components/Overlay";
import { Modal } from "../../components/Modal";
import { extractDate, subadminAccessChange } from "../../utils/functions";
import * as XLSX from 'sheetjs-style';
import { saveAs } from "file-saver";

// Mui & material UI
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import SearchBar from "material-ui-search-bar";
import Pagination from '@mui/material/Pagination';
import { makeStyles } from "@material-ui/core/styles";
import { TextField, Popover, Box } from "@mui/material";
import PaginationItem from '@mui/material/PaginationItem';

import {
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination
} from "@material-ui/core";

// icons 
import { HiOutlineBars3BottomLeft } from "react-icons/hi2";
import { RxCross2, RxCrossCircled } from "react-icons/rx";
import { HiMiniArrowLeft, HiMiniArrowRight } from "react-icons/hi2";
import { AiOutlineDownload } from "react-icons/ai";
import { FiPlusCircle } from "react-icons/fi";
import { LuPencilLine } from "react-icons/lu";
import { FiEye } from "react-icons/fi";

import EyeIcon from "../../assets/images/eye-tick.png";
import UserIcon from "../../assets/images/users-check.png";

// Elements

import {
    DashboardContainer,
    DashboardWrapper,
    DashboardHeading,
    SearchFilterContainer,
    DashHeading,
    Button,
    DeleteButton,
    ProfileDetailForm,
    SelectedColumnContainer,
} from "./BlockElement";
import zIndex from "@material-ui/core/styles/zIndex";
import NoResults from "../../components/NoResult";


const useStyles = makeStyles((theme) => ({
    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 6px', // adds vertical spacing between rows
    },
    tableMainContainer: {
        maxHeight: "65vh",
        overflowX: "auto",
        overflowY: "auto",
        borderTopLeftRadius: "4px",
        borderTopRightRadius: "4px",
    },
    tableHeadingRow: {
        position: "sticky", // Make header sticky
        top: 0, // Stick to the top
        zIndex: 1, // Ensure it appears above other rows
        background: "#FFFFFF", // Header background color
        border: "1px solid rgba(17, 153, 38, 0.20)",

    },
    tableBodyRow: {
        background: "#FFFFFF",
        // border: "1px solid rgba(17, 153, 38, 0.20)",

        "&:hover": {
            backgroundColor: "#f5f5f5",
        },
    },
    tableHeadingCell: {
        // padding: "0.5rem 1rem !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#1C2D28",
        fontWeight: "500",
        // border: "1px solid #D9E3D9",
        whiteSpace: "nowrap",
        background: "#FFFFFF",
        border: "none"
    },
    textMiddle: {
        // padding: "0.4rem 1rem !important",
        verticalAlign: "middle !important",
        textAlign: "center",
        fontSize: "14px",
        color: "#484848",
        fontFamily: "Roboto",
        fontWeight: "400",
        background: "#FFFFFF",
        border: "none"
    },
    tablePaginationStyle: {
        borderTop: "1px solid #0000001a",
        borderRadius: "0rem 0rem 0.4rem 0.4rem",
        overflowY: "hidden",
    },
    paginationContainer: {
        marginTop: "2rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    }
}));


const BlockManagement = ({ setUsers, userData }) => {
    const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

    const blockManagementPermissions = adminData?.adminpermissions?.modules?.find(
        (module) => module.moduleName === "Blacklist Word Management"
    )?.permissions || {};


    const canView = !!blockManagementPermissions.view;
    const canAdd = !!blockManagementPermissions.add;
    const canEdit = !!blockManagementPermissions.edit;
    const canDelete = !!blockManagementPermissions.delete;
    const canBlockUnblock = !!blockManagementPermissions.blockUnblock;
    const canDownload = !!blockManagementPermissions.download;

    const classes = useStyles();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [excelData, setExcelData] = useState([]);


    const [deleteModal, setDeleteModal] = useState(false);
    const [filterStatus, setFilterStatus] = useState("all");



    // For Pagination
    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalDocs, setTotalDocs] = useState(0);

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(1); // Reset to the first page when rows per page change
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage); // Update page and trigger data fetch
    };


    // For Select checkbox
    const [selectedRows, setSelectedRows] = useState([]);

    useEffect(() => {
        if (tableData.length === 0) {
            setSelectedRows([]);
        }
    }, [tableData]);

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedRows(tableData.map((item) => item._id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleSelectRow = (id) => {
        const newSelectedRows = selectedRows.includes(id)
            ? selectedRows.filter((rowId) => rowId !== id)
            : [...selectedRows, id];
        setSelectedRows(newSelectedRows);
    };

    const handleClearSelection = () => {
        setSelectedRows([]);
    };

    const [anchorEl, setAnchorEl] = useState(null);



    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget); // Open the filter popover
    };

    const handleClose = () => {
        setAnchorEl(null); // Only close the popover without resetting
    };



    const open = Boolean(anchorEl);
    const id = open ? "filter-popover" : undefined;

    // For Search functionality
    const [searchTerm, setSearchTerm] = useState("");

    function myDeb(call, d = 1000) {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                call(...args);
            }, d);
        };
    }

    const SearchAccountManagement = myDeb((search) => {
        setSelectedRows([]);
        setSearchTerm(search);
        setPage(1); // Reset to the first page on search
    });

    const cancelSearch = () => {
        setSearchTerm("");
        setPage(1); // Reset to the first page when search is canceled
    };



    // Get user data
    useEffect(() => {
        getBlackListWord(page)
        getExcelData()
            .then((res) => res.json())
            .then((data) => setExcelData(data))
            .catch((error) => console.error("Error fetching data:", error));

    }, [page, rowsPerPage, searchTerm, filterStatus]);

    const getBlackListWord = async (currentPage) => {
        setIsLoading(true);
        setTotalDocs(0);

        try {
            const { data } = await axios.get(`/private/getBlackListWord?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}`, {
                status: String(filterStatus), // Ensure status is a string
            });

            setTableData(data?.data?.docs);
            setTotalDocs(data?.data?.totalDocs);
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else if (error?.response?.status === 901) {
                subadminAccessChange(navigate);
                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };




    // Delete user functionality - handles both single and multiple deletions
    const DeleteUser = async (id = null) => {
        const idsToDelete = id ? [id] : selectedRows;

        if (idsToDelete.length === 0) {
            toast.error('No users selected for deletion', {
                position: "top-right",
            });
            return;
        }

        setIsLoading(true);

        try {
            // Using axios.request to support sending data in the body with DELETE method
            const { data } = await axios({
                method: 'delete',
                url: `/private/deleteBlackListWord`,
                data: {
                    ids: idsToDelete,
                },
            });

            setDeleteModal(false);
            toast.success(data?.message);
            handleClearSelection();
            setSelectedRows([]);  // Clear selected rows after deletion
            getBlackListWord(page);  // Refresh table after deletion
        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                toast.error('Something went wrong', {
                    position: "top-right",
                });
            }
        } finally {
            setIsLoading(false);
        }
    };



    const handleDownload = () => {
        // Format keys: convert camelCase to space-separated & capitalize, handle _id
        const formatKey = (key) => {
            if (key === '_id') return 'User Id';
            return key
                .replace(/([a-z])([A-Z])/g, '$1 $2')  // Add space before capital letters
                .replace(/^./, str => str.toUpperCase()); // Capitalize first letter
        };

        // Function to format date if key is createdAt
        const formatValue = (key, value) => {
            if (key === "createdAt" && value) {
                return new Date(value).toLocaleString("en-US", {
                    month: "2-digit",
                    day: "2-digit",
                    year: "numeric",
                    hour: "numeric",
                    minute: "2-digit",
                    hour12: true
                });
            }
            return value;
        };

        // Format data with formatted headers
        const formattedData = excelData.map(item => {
            const newItem = {};
            Object.entries(item).forEach(([key, value]) => {
                newItem[formatKey(key)] = formatValue(key, value);
            });
            return newItem;
        });

        // Create worksheet from formatted data
        const worksheet = XLSX.utils.json_to_sheet(formattedData);

        // Auto-calculate column widths
        const keys = Object.keys(formattedData[0] || {});
        const colWidths = keys.map(key => {
            const maxLength = Math.max(
                key.length,
                ...formattedData.map(row => (row[key] ? row[key].toString().length : 0))
            );
            return { wch: maxLength + 2 };
        });
        worksheet["!cols"] = colWidths;

        // Bold header row (row 0)
        keys.forEach((key, index) => {
            const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
            if (worksheet[cellAddress]) {
                worksheet[cellAddress].s = {
                    font: { bold: true }
                };
            }
        });

        // Create workbook and append sheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Write and download
        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array"
        });

        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "table_data.xlsx");
    };




    const getExcelData = async () => {

        try {
            const { data } = await axios.get(`/private/getExcelData`);
            setExcelData(data?.data);


        } catch (error) {
            if (error?.response?.status === 419) {
                localStorage.clear();
                Cookies.remove("showProfileSidebar");
                setUsers("");

                toast.error(`${error.response.data?.message}`, {
                    position: "top-right",
                });

                navigate("/");
            } else {
                console.log("error", error?.response)
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <DashboardContainer>
                <DashboardWrapper>
                    <ProfileDetailForm>
                        <DashboardHeading>
                            Blacklist Word Manager
                        </DashboardHeading>

                        <SearchFilterContainer>
                            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                                <SearchBar
                                    style={{
                                        minWidth: "25rem",
                                        height: "38px",
                                        borderRadius: "20px",
                                        backgroundColor: "#F8F9FB",
                                        color: "#212121",
                                        fontStyle: "Italic",
                                        fontWeight: 300,
                                        fontSize: "15px",
                                        fontFamily: "Roboto",
                                    }}
                                    className={"heightfix"}
                                    onChange={(e) => {
                                        SearchAccountManagement(e);
                                    }}
                                    onCancelSearch={cancelSearch}
                                    placeholder="Search by Blacklist ID, Word..."
                                    inputProps={{ maxLength: 30 }}
                                />
                            </div>
                            <div style={{ display: "flex", gap: "1rem" }}>
                                {!(!canDownload && adminData?.userType === "subAdmin") && (
                                    <Button
                                        type="button"
                                        style={{ backgroundColor: "#5088FB", color: "#FFFFFF", border: "1px solid #5088FB", fontSize: "14px", padding: "6px 8px" }}

                                    >
                                        <div onClick={handleDownload}>Export as xlsx <AiOutlineDownload style={{ fontSize: "1.3rem" }} /></div>
                                    </Button>
                                )}

                                {!(!canAdd && adminData?.userType === "subAdmin") && (
                                    <Button
                                        type="button"
                                        style={{ backgroundColor: "#5088FB", color: "#FFFFFF", border: "1px solid #5088FB", fontSize: "14px", padding: "6px 8px" }}
                                        onClick={() => navigate(`/addUpdateBlockManagement`)}
                                    >
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem" }}><FiPlusCircle style={{ fontSize: "1.3rem" }} /> Create New </div>
                                    </Button>
                                )}

                            </div>
                        </SearchFilterContainer>


                        {selectedRows.length > 0 && (
                            <SelectedColumnContainer>
                                <DeleteButton
                                    type="button"
                                    className="buttonWidthResponsive"
                                    onClick={() => {
                                        setDeleteModal(true);
                                    }}
                                >
                                    Delete
                                </DeleteButton>
                                <div className="column-selected">{selectedRows.length} Selected</div>
                                <div
                                    className="container-clear-selection"
                                    onClick={handleClearSelection}
                                >
                                    <RxCrossCircled />
                                    <span className="column-selected">Clear Response</span>
                                </div>
                            </SelectedColumnContainer>
                        )}

                        <TableContainer
                            className={classes.tableMainContainer}
                        >
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow className={classes.tableHeadingRow}>
                                        {!(!canDelete && adminData?.userType === "subAdmin") && (
                                            <TableCell className={classes.tableHeadingCell}>
                                                <div style={{ marginLeft: "1rem", display: "flex", gap: "1rem" }}>
                                                    <Checkbox
                                                        style={{ padding: "2px" }}
                                                        indeterminate={selectedRows.length > 0 && selectedRows.length < tableData.length}
                                                        checked={tableData.length > 0 && tableData.every((item) => selectedRows.includes(item._id))}
                                                        onChange={handleSelectAll}
                                                        color="primary"
                                                    />
                                                    <div>  S.No</div>
                                                </div>
                                            </TableCell>
                                        )}
                                        {/* <TableCell className={classes.tableHeadingCell}>
                                            S.No
                                        </TableCell> */}
                                        <TableCell className={classes.tableHeadingCell}>
                                            Action
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Created On
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Blacklist ID
                                        </TableCell>
                                        <TableCell className={classes.tableHeadingCell}>
                                            Word
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {tableData && tableData.length > 0 ? (
                                    <>
                                        <TableBody>
                                            {tableData.map((user, index, block) => (
                                                <TableRow className={classes.tableBodyRow} key={user._id}>
                                                    {!(!canDelete && adminData?.userType === "subAdmin") && (
                                                        <TableCell className={classes.textMiddle}>
                                                            <div style={{ marginLeft: "1rem", display: "flex", gap: "1rem" }}>
                                                                <Checkbox
                                                                    style={{ padding: "2px" }}
                                                                    checked={selectedRows.includes(user._id)}
                                                                    onChange={() => handleSelectRow(user._id)}
                                                                    color="primary"
                                                                    disabled={!canDelete && adminData?.userType == "subAdmin"} // Disable if canDelete is false
                                                                />
                                                                <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                            </div>

                                                        </TableCell>
                                                    )}
                                                    {/* <TableCell className={classes.textMiddle}>
                                                        <div>{index + 1 + rowsPerPage * (page - 1)}</div>
                                                    </TableCell> */}
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", fontSize: "1.1rem", cursor: "pointer", color: "#5088FB" }}>
                                                            <FiEye onClick={() => navigate(`/blockManagementDetails/${user._id}`)} />

                                                            {!(!canEdit && adminData?.userType === "subAdmin") && (
                                                                <LuPencilLine onClick={() => navigate(`/addUpdateBlockManagement`, { state: { blockData: user } })} />
                                                            )}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{extractDate(get(user, "createdAt", "---"))}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div>{get(user, "blackListId", "---")}</div>
                                                    </TableCell>
                                                    <TableCell className={classes.textMiddle}>
                                                        <div style={{ textTransform: "capitalize", color: "#484848", fontSize: "14px", fontWeight: "700" }}>
                                                            {get(user, "word", "---")}
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </>
                                ) : (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={13} align="center" style={{ padding: "2rem", border: "none" }}>
                                                    <DashHeading style={{ textAlign: "center", padding: "2rem" }}><NoResults /></DashHeading>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                )}
                            </Table>
                        </TableContainer>
                        {(tableData && tableData.length > 0) && (
                            <>
                                <Stack spacing={2} className={classes.paginationContainer}>
                                    <Pagination
                                        count={Math.ceil(totalDocs / rowsPerPage)} // Total number of pages based on the count and rowsPerPage
                                        page={page}
                                        onChange={(event, value) => handleChangePage(event, value)} // Update page
                                        renderItem={(item) => (
                                            <PaginationItem
                                                slots={{ previous: HiMiniArrowLeft, next: HiMiniArrowRight }}
                                                {...item}
                                            />
                                        )}
                                    />
                                </Stack>
                            </>
                        )}

                    </ProfileDetailForm>
                </DashboardWrapper>
            </DashboardContainer>

            {/* Modal for Delete User  */}
            <Modal
                maxWidth="lg"
                width="360px"
                RoundedCorners={true}
                isOpen={deleteModal}
                onClose={() => {
                    setDeleteModal(false);
                }}
                backgroundModal={false}
                backgroundModalContent={false}
                title={
                    <div>
                        <div className="d-flex align-items-center justify-content-end">
                            <RxCross2
                                style={{
                                    cursor: "pointer",
                                }}
                                onClick={() => { setDeleteModal(false); }}
                            />
                        </div>
                        <p className="profile-section-text">Delete Word</p>
                        <div className="logout-header" style={{ paddingTop: "0px" }}>Are you sure you want to delete this Word? Please confirm.</div>
                    </div>
                }
                content={
                    <>
                        <div className="logout-button-group">
                            <div
                                className="cancel-button"
                                onClick={() => {
                                    setDeleteModal(false);
                                }}
                            >
                                Cancel
                            </div>
                            <div className="logout-button" style={{ background: "#5088FB" }} onClick={() => DeleteUser(null)}>
                                Yes
                            </div>
                        </div>
                    </>
                }
            />
            {isLoading && <Overlay />}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        userData: state.userData,
        locationData: state.locations,
        defaultState: state.defaultState,
        sidebar: state.sidebar,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setUsers: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_USER,
                updatedUser: updatedValue,
            });
        },
        setDefaultState: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_DEFAULT,
                updateDefault: updatedValue,
            });
        },
        setSidebar: (updatedValue) => {
            dispatch({
                type: actionTypes.UPDATE_SIDEBAR,
                updateSidebar: updatedValue,
            });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BlockManagement);




